export const REUSE_PARAM_KEYS = ["applicationId", "returnTo"] as const;

export function copyReuseParams(
  from: URLSearchParams,
  to: URLSearchParams
): URLSearchParams {
  for (const key of REUSE_PARAM_KEYS) {
    const value = from.get(key);
    if (value) to.set(key, value);
  }
  return to;
}

export function isApplicationReuseMode(searchParams: URLSearchParams): boolean {
  return Boolean(searchParams.get("applicationId"));
}

export function paymentReturnPath(applicationId: string): string {
  return `/application/payment?applicationId=${encodeURIComponent(
    applicationId
  )}`;
}

export function safeInternalPath(
  value: string | null | undefined,
  fallback: string
): string {
  if (!value) return fallback;
  if (
    !value.startsWith("/") ||
    value.startsWith("//") ||
    value.includes("://")
  ) {
    return fallback;
  }
  return value;
}

export function toIsoDate(value: unknown): string | null {
  if (value == null || value === "") return null;
  if (typeof value === "string") {
    const iso = value.match(/^(\d{4}-\d{2}-\d{2})/);
    if (iso) return iso[1];
    const us = value.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (us) {
      const month = us[1].padStart(2, "0");
      const day = us[2].padStart(2, "0");
      return `${us[3]}-${month}-${day}`;
    }
  }
  const d = value instanceof Date ? value : new Date(String(value));
  if (Number.isNaN(d.getTime())) return null;
  return d.toISOString().slice(0, 10);
}

export function buildAvailabilityReusePath({
  abbreviation,
  applicationId,
  moveInDate,
}: {
  abbreviation: string;
  applicationId: string;
  moveInDate?: string | null;
}): string {
  const params = new URLSearchParams();
  params.set("applicationId", applicationId);
  params.set("returnTo", paymentReturnPath(applicationId));
  if (moveInDate) params.set("moveInDate", moveInDate);
  return `/availability/${encodeURIComponent(
    abbreviation
  )}?${params.toString()}`;
}

export function buildAvailabilityUnitPath({
  propertyCode,
  unitNumber,
  moveInDate,
  searchParams,
}: {
  propertyCode: string;
  unitNumber: string;
  moveInDate: string;
  searchParams: URLSearchParams;
}): string {
  const params = new URLSearchParams();
  params.set("moveInDate", moveInDate);
  copyReuseParams(searchParams, params);
  return `/availability/${encodeURIComponent(
    propertyCode
  )}/units/${encodeURIComponent(unitNumber)}?${params.toString()}`;
}

export function buildAvailabilityListPath({
  propertyCode,
  moveInDate,
  searchParams,
}: {
  propertyCode: string;
  moveInDate: string;
  searchParams: URLSearchParams;
}): string {
  const params = new URLSearchParams();
  params.set("moveInDate", moveInDate);
  copyReuseParams(searchParams, params);
  return `/availability/${encodeURIComponent(
    propertyCode
  )}?${params.toString()}`;
}
